import { Component, ViewChild, Input, Injectable, Inject } from '@angular/core';
import { NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { ToasterService, ToasterConfig } from 'angular5-toaster';
// Modelos
import { User } from '../../models/user';
// Servicios
import { CatalogsService } from '../../services/catalogs/catalogs.service';
import { ComplementsService } from "../../services/complements/complements.service";
import { StorageService } from '../../services/storage.service';
import { ENPOINT } from '../../services/endpoint';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';

/////////////////////////// LENGUAJE DATEPICKER /////////////////////////////////////
const I18N_VALUES = {
  'es': {
    weekdays: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'],
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
  },
  'en': {
    weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  }
};

@Injectable()
export class I18n {
  lang; language;
  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
  ) {
    this.lang = this.storage.get('LOCAL_STORAGE');

    if (this.lang === 'es') {
      this.language = this.lang;
    } else {
      this.language = 'en';
    }
  }
}

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  constructor(private _i18n: I18n) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}
////////////////////////////////////////////////////////////////////////////////////////

@Component({
  selector: 'app-complement-loaded',
  templateUrl: './complement-loaded.component.html',
  styleUrls: ['./complement-loaded.component.scss'],
  providers: [ComplementsService, I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }]
})
export class ComplementLoadedComponent {
  @ViewChild('mydatatable') table: any;

  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  busy = false;
  mostrarxml = false;
  flagDescargaZip = false;
  loadingExcel = false;

  rangoFecha = false;
  sinFechaI = true;
  sinFechaF = true;
  fechaInicial;
  fechaFinal;
  
  fechaInicialInput: string;
  fechaFinalInput: string;
  proveedorInput: string;
  uuidComplemento: string;
  folioFactura: string;

  selected = [];
  salida = {
    complemento: []
  };
  proveedores$: Observable<any>;
  proveedoresLoading = false;
  proveedorinput$ = new Subject<string>();
  
  modalDetalle;
  closeResult: string;

  public user: User;
  private basePath;

  complementos = [];
  docRelacionado = [];

  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });
  sinPDF: string;
  sinXML: string;
  sinArchivos: string;
  rangoLabel: string;

  constructor(
    private modalService: NgbModal,
    private catalogs: CatalogsService,
    private _ComplementsService: ComplementsService,
    private storageService: StorageService,
    private translate: TranslateService,
    private toasterService: ToasterService
    ) {
      this.translate.get('texto.noHayInformacionLabel').subscribe(
        text => {
          this.messages.emptyMessage = text;
      });
  
      this.translate.get('texto.totalLabel').subscribe(
        text => {
          this.messages.totalMessage = text;
      });
  
      this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
        this.messages.selectedMessage = text;
      });

      this.translate.get('texto.archivoPDFLabel').subscribe(
        text => {
          this.sinPDF = text;
        });

      this.translate.get('texto.archivoXMLLabel').subscribe(
        text => {
          this.sinXML = text;
        });

      this.translate.get('texto.noAdjuntosLabel').subscribe(
        text => {
          this.sinArchivos = text;
        });

      this.translate.get('texto.rangoFechasValido').subscribe(
        text => {
          this.rangoLabel = text;
        });

      this.basePath = ENPOINT.url;
      this.getProveedores();
      this.user = this.storageService.getCurrentUser();      
    }

  getXLSReporte() {
    let params = `?desde=${this.fechaInicialInput}&hasta=${this.fechaFinalInput}`;
    if (this.proveedorInput != '') {
      params = params + `&proveedor=${this.proveedorInput}`;
    }
    if (this.uuidComplemento) {
      params = params + `&uuid-complemento=${this.uuidComplemento}`;
    }
    if (this.folioFactura) {
      params = params + `&folio-factura=${this.folioFactura}`;
    }

    this.loadingExcel = true;

    this._ComplementsService.downloadExcelReport(params).subscribe(      
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'reporte-complementos-cargados.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      (error) => {
        console.error('Error al descargar el reporte:', error);
      },
      () => {
        this.loadingExcel = false;
      }
    );
  }

  descargarZip() {
    for (let i = 0; i < this.selected.length; i++) {

      let xmlDoc;
      if (this.selected[i].xml !== '') {
        xmlDoc = this.selected[i].rutaXml;
      } else {
        xmlDoc = '';
      }

      let pdfDoc;
      if (this.selected[i].pdf !== '') {
        pdfDoc = this.selected[i].rutaPdf;
      } else {
        pdfDoc = '';
      }

      let uuidDoc;
      if (this.selected[i].uuid !== '') {
        uuidDoc = this.selected[i].uuid;
      } else {
        uuidDoc = '';
      }

      const objectFacturas = {
        rutaPdf: pdfDoc,
        rutaXml: xmlDoc,
        uuid: uuidDoc
      };

      this.salida.complemento.push(objectFacturas);
    }
    
    this._ComplementsService.downloadZip(this.salida).subscribe(
      data => {
        this.salida.complemento = [];
        const respuesta = data.result.mensaje;
        const win = window.open('data:application/zip;base64,' + respuesta, '_blank');
        if (win) {
          win.focus();
        } else {
          alert('Por favor activa los popups en tu navegador');
        }
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        }
      }
    );
  }

  keyUpDatePicker(e) {
    e.target.value = '';
    this.fechaInicialInput = (<HTMLInputElement>document.getElementById('fechai')).value;
    this.fechaFinalInput = (<HTMLInputElement>document.getElementById('fechaf')).value;

    if (this.fechaInicialInput == undefined || this.fechaInicialInput == '') {
      this.sinFechaI = true;
      this.rangoFecha = false;
    }
    if (this.fechaFinalInput == undefined || this.fechaFinalInput == '') {
      this.sinFechaF = true;
      this.rangoFecha = false;
    }
  }

  onDateSelectIncial(e) {
    this.fechaInicial = e;
    this.sinFechaI = false;
    this.rangoFecha = false;
    (<HTMLInputElement>document.getElementById('fechaf')).value = null;
  }

  onDateSelectFinal(e) {
    this.fechaFinal = e;
    this.rangoFecha = false;
    this.sinFechaF = false;
    // coprobar fechas validas
    if (this.fechaInicial.year > this.fechaFinal.year) {
        this.rangoFecha = false;
        this.toasterService.pop('error', 'ERROR', this.rangoLabel);
    }
    else {
      if (this.fechaInicial.year  == this.fechaFinal.year) {
        if (this.fechaInicial.month > this.fechaFinal.month) {
            this.rangoFecha = false;
            this.toasterService.pop('error', 'ERROR', this.rangoLabel);
        } else {
          if (this.fechaInicial.month  == this.fechaFinal.month) {
            if (this.fechaInicial.day > this.fechaFinal.day){
              this.rangoFecha = false;
              this.toasterService.pop('error', 'ERROR', this.rangoLabel);
            }
            else {
              this.rangoFecha = true;
            }
          }  
          else {
            this.rangoFecha = true;
          }
        }
      }
      else {
        this.rangoFecha = true;
      }
    }
  }

  getProveedores() {
    this.complementos = [];
    this.proveedores$ = concat(of([]),
    this.proveedorinput$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      
      tap(() => this.proveedoresLoading = true),
      switchMap(term =>
        this.catalogs.obtenerProveedoresBusqueda(term).pipe(
          catchError(() => of([])), // empty list on error
          tap(() => this.proveedoresLoading = false)
        ))
      )
    );
  }
  
  toggleExpandRow(row) {
    this.table.rowDetail.toggleExpandRow(row);
  }

  getComplementos() {
    this.busy = true; 
    this.uuidComplemento = (<HTMLInputElement>document.getElementById('UUIDComplemento')).value;
    this.folioFactura = (<HTMLInputElement>document.getElementById('facturaRelacionada')).value;
    this.fechaInicialInput = (<HTMLInputElement>document.getElementById('fechai')).value;
    this.fechaFinalInput = (<HTMLInputElement>document.getElementById('fechaf')).value;
    if ( this.proveedorInput == null) {
      this.proveedorInput = '';
    }

    let data = {
      desde: this.fechaInicialInput,
      hasta: this.fechaFinalInput,
      proveedor: this.proveedorInput,
      uuidComplemento: this.uuidComplemento,
      folioFactura: this.folioFactura
    }

    this._ComplementsService.getComplementosCargados(data).subscribe(
      data => {
        this.complementos = data.complemento;
        if (data.complemento) {
          this.mostrarxml = true;
        }
        this.busy = false; 
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        }
      }
    );
  }

  openMasDetalle(masDetalle, row) {    
    this.docRelacionado = [];
    let uuid = row.uuid;
    this._ComplementsService.getDocsRelacionados(uuid).subscribe(
      data => {
        this.docRelacionado = data.docRelacionadoComplemento;
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      }
    );
    this.modalDetalle = this.modalService.open(masDetalle, { centered: true, keyboard: false, backdrop: true, size: 'lg', windowClass : "myCustomModalClass" });
    this.modalDetalle.result.then((result) => {
    this.closeResult = `Closed with: ${result}`;

    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  } 
  //funcion propia para componente modal
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);

    if (this.selected.length > 0) {
      this.flagDescargaZip = true;
    } else {
      this.flagDescargaZip = false;
    }
  }

  descargaXml(row) {
    const xmlRuta = row.rutaXml;

    if (xmlRuta) {
      let ruta = btoa(xmlRuta);
      
      this._ComplementsService.downloadXml(ruta).subscribe(
        (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${row.uuid || row.emisor}.xml`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        (error) => {
          console.error('Error al descargar el XML:', error);
        }
      );

    } else {
      this.toasterService.pop('error', 'ERROR', (this.sinArchivos + ': ' + this.sinXML));
    }
  }

  descargaPdfNC(row) {
    const pdfRuta = row.rutaPdf;

    if (pdfRuta) {
      let ruta = btoa(pdfRuta);
      
      this._ComplementsService.downloadPdf(ruta).subscribe(
        (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${row.uuid || row.emisor}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        (error) => {
          console.error('Error al descargar el PDF:', error);
        }
      );

    } else {
      this.toasterService.pop('error', 'ERROR', (this.sinArchivos + ': ' + this.sinPDF));
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/app/pages/complement-loaded/complement-loaded.component.ts